import piece1 from '../images/3D-art/01kasten/01-12pianos.jpeg';
import piece2 from '../images/3D-art/01kasten/02-gridAndDrop.jpeg';
import piece3 from '../images/3D-art/01kasten/03-blackCabinet.jpeg';
import piece4 from '../images/3D-art/01kasten/04-greenCabinet.jpeg';
import piece5 from '../images/3D-art/01kasten/05-blackHexagon.jpeg';
import piece6 from '../images/3D-art/01kasten/06-redBox.jpeg';
import piece7 from '../images/3D-art/01kasten/07-blackBoxRedBox.jpeg';
import piece8 from '../images/3D-art/01kasten/08-underlayment.jpeg';
import piece9 from '../images/3D-art/01kasten/09-BirchBox.jpeg';
import piece10 from '../images/3D-art/02gips/10-plasterSketch.jpeg';
import piece11 from '../images/3D-art/02gips/11-plasterSketch.jpeg';
import piece12 from '../images/3D-art/02gips/12-plasterSketch.jpeg';
import piece13 from '../images/3D-art/02gips/13-plasterCocon.jpeg';
import piece14 from '../images/3D-art/02gips/14-plasterHoles.jpeg';
import piece15 from '../images/3D-art/02gips/15-plasterTurtle.jpeg';
import piece16 from '../images/3D-art/02gips/16-plasterRed.jpeg';
import piece17 from '../images/3D-art/02gips/17-plasterMaria.jpeg';
import piece18 from '../images/3D-art/02gips/18-plaster.jpeg';
import piece19 from '../images/3D-art/02gips/19-plasterButterfly.jpeg';
import piece20 from '../images/3D-art/02gips/20-plaster.jpeg';
import piece21 from '../images/3D-art/02gips/21-plasterAndRoster.jpeg';
import piece22 from '../images/3D-art/02gips/22-plasterShell.jpeg';
import piece23 from '../images/3D-art/03mergel/23-marlGate.jpeg';
import piece24 from '../images/3D-art/03mergel/24-marlBoat.jpeg';
import piece25 from '../images/3D-art/03mergel/25-marlCloves.jpeg';
import piece26 from '../images/3D-art/04keramiek/26-ceramicLamp.jpeg';
import piece27 from '../images/3D-art/04keramiek/27-ceramic2peace.jpeg';
import piece28 from '../images/3D-art/04keramiek/28-ceramicBigWhite.jpeg';
import piece29 from '../images/3D-art/04keramiek/29-ceramicWoman.jpeg';
import piece30 from '../images/3D-art/04keramiek/30-ceramic4x.jpeg';
import piece31 from '../images/3D-art/04keramiek/31-ceramicShellSpiral.jpeg';
import piece32 from '../images/3D-art/04keramiek/32-ceramicPurpleWhite.jpeg';
import piece33 from '../images/3D-art/04keramiek/33-ceramic5piece.jpeg';
import piece34 from '../images/3D-art/04keramiek/34-ceramicGreen.jpeg';
import piece35 from '../images/3D-art/04keramiek/35-ceramicCloud.jpeg';
import piece36 from '../images/3D-art/04keramiek/36-ceramicPearlTree.jpeg';
import piece37 from '../images/3D-art/04keramiek/37-ceramicYellowMirror.jpeg';
import piece38 from '../images/3D-art/04keramiek/38-ceramicWomanGreat.jpeg';
import piece39 from '../images/3D-art/05brons/39-bronze.jpeg';
import piece40 from '../images/3D-art/05brons/40-bronze.jpeg';
import piece41 from '../images/3D-art/05brons/41-bronzeBig.jpeg';
import piece42 from '../images/3D-art/05brons/42-bronzeBig.jpeg';
import piece43 from '../images/3D-art/05brons/43-Aluminum.jpeg';
import piece44 from '../images/3D-art/06marmer/44-marbleRed.jpeg';
import piece45 from '../images/3D-art/06marmer/45-marbleWoman.jpeg';
import piece46 from '../images/3D-art/06marmer/46-marbleButterfly.jpeg';
import piece47 from '../images/3D-art/06marmer/47-marbleButterfly.jpeg';
import piece48 from '../images/3D-art/06marmer/48-marblePinkCloud.jpeg';
import piece49 from '../images/3D-art/06marmer/49-marblePinkCloud.jpeg';
import piece50 from '../images/3D-art/06marmer/50-marbleTree.jpeg';
import piece51 from '../images/3D-art/06marmer/51-marble.jpeg';
import piece52 from '../images/3D-art/06marmer/52-marbleHome.jpeg';
import piece53 from '../images/3D-art/07hout/53-wood.jpeg';
import piece54 from '../images/3D-art/07hout/54-woodOutline.jpeg';
import piece55 from '../images/3D-art/07hout/55-woodOutline.jpeg';
import piece56 from '../images/3D-art/07hout/56-woodSmall.jpeg';
import piece57 from '../images/3D-art/07hout/57-woodPlank.jpeg';
import piece58 from '../images/3D-art/07hout/58-wood6.jpeg';
import piece59 from '../images/3D-art/07hout/59-woodMapleHole.jpeg';
import piece60 from '../images/3D-art/07hout/60-woodBirch.jpeg';
import piece61 from '../images/3D-art/07hout/61-wood3.jpeg';
import piece62 from '../images/3D-art/07hout/62-woodBolls.jpeg';
import piece63 from '../images/3D-art/07hout/63-woodMapleBirch.jpeg';
import piece64 from '../images/3D-art/07hout/64-woodPoplar.jpeg';
import piece65 from '../images/3D-art/07hout/65-woodPoplarBerk.jpeg';
import piece66 from '../images/3D-art/07hout/66-woodPoplar2.jpeg';
import piece67 from '../images/3D-art/07hout/67-woodBouquet.jpeg';
import piece68 from '../images/3D-art/07hout/68-woodBouquet.jpeg';
import piece69 from '../images/3D-art/08ruitelijkeTk/69-spacialCopper.jpeg';
import piece70 from '../images/3D-art/08ruitelijkeTk/70-spacialThreatCopper.jpeg';
import piece71 from '../images/3D-art/08ruitelijkeTk/71-spacialAluminium.jpeg';
import piece72 from '../images/3D-art/08ruitelijkeTk/72-spacialZoom.jpeg';
import piece73 from '../images/3D-art/08ruitelijkeTk/73-spacial.jpeg';
import piece74 from '../images/3D-art/09HekApeldoorn/74-apeldoorn.jpeg';
import piece75 from '../images/3D-art/09HekApeldoorn/75-apeldoorn.jpeg';
import piece76 from '../images/3D-art/09HekApeldoorn/76-apeldoorn.jpeg';
import piece78 from '../images/3D-art/09HekApeldoorn/77-apeldoorn.jpeg';
import piece79 from '../images/3D-art/09HekApeldoorn/78-apeldoorn.jpeg';
import piece80 from '../images/3D-art/09HekApeldoorn/80-apeldoorn.jpeg';
import piece81 from '../images/3D-art/010laatsteWerk/81-latest4.jpeg';
import piece82 from '../images/3D-art/010laatsteWerk/82-latestGreen.jpeg';
import piece83 from '../images/3D-art/010laatsteWerk/83-latestMulticolor.jpeg';
import piece84 from '../images/3D-art/010laatsteWerk/84-latestBlackWhite.jpeg';
import piece85 from '../images/3D-art/010laatsteWerk/85-latestHolesColors.jpeg';
import piece86 from '../images/3D-art/010laatsteWerk/86-latestDrawing.jpeg';
import piece87 from '../images/3D-art/010laatsteWerk/87-latestPorcelaine.jpeg';
import piece88 from '../images/3D-art/010laatsteWerk/88-latestWood.jpeg';
import piece89 from '../images/3D-art/010laatsteWerk/89-latestWoodBig.jpeg';
import piece90 from '../images/3D-art/010laatsteWerk/90-latestWoodBlue.jpeg';
import piece91 from '../images/3D-art/010laatsteWerk/91-latestWoodInsideOut.jpeg';
import piece92 from '../images/3D-art/010laatsteWerk/92-latestWoodInsidOut.jpeg';

export type ArtPiece = {
  imageSRC: string | any;
  material: string;
  size: string;
};

export const ArtPieces: ArtPiece[] = [
  {
    imageSRC: piece1,
    material: 'lacquered wood plywood',
    size: 'room 01 Breda',
  },
  {
    imageSRC: piece2,
    material: 'Chalk on paper and mixed techniques',
    size: '250x150 & 160x4',
  },
  {
    imageSRC: piece3,
    material: 'Black cabinet wood lacquer',
    size: '104x104x200',
  },
  {
    imageSRC: piece4,
    material: 'Wood plywood acrylic',
    size: '106x106x240',
  },
  {
    imageSRC: piece5,
    material: 'Wood plywood lacquer plaster',
    size: '160x110x80',
  },
  {
    imageSRC: piece6,
    material: 'Wood plywood acrylic',
    size: '215x103x103',
  },
  {
    imageSRC: piece7,
    material: 'Metal sheet strip iron and copper',
    size: '110x110x200',
  },
  {
    imageSRC: piece8,
    material: 'Underlayment',
    size: '118x118x200',
  },
  {
    imageSRC: piece9,
    material: 'Birch plywood, metal',
    size: '135x135x200',
  },
  {
    imageSRC: piece10,
    material: 'Plaster sketch',
    size: '27x16x37',
  },
  {
    imageSRC: piece11,
    material: 'Plaster sketch',
    size: '18x12x34',
  },
  {
    imageSRC: piece12,
    material: 'Plaster, acrylic on paper',
    size: '54x54x110 & 100x200',
  },
  {
    imageSRC: piece13,
    material: 'Plaster',
    size: '58x58x103',
  },
  {
    imageSRC: piece14,
    material: 'Plaster',
    size: '80x45x136',
  },
  {
    imageSRC: piece15,
    material: 'Plaster',
    size: '40x50x130',
  },
  {
    imageSRC: piece16,
    material: 'Plaster',
    size: '60x60x105',
  },
  {
    imageSRC: piece17,
    material: 'Plaster, acrylic',
    size: '55x50x120',
  },
  {
    imageSRC: piece18,
    material: 'Plaster',
    size: '80x45x136',
  },
  {
    imageSRC: piece19,
    material: 'Plaster',
    size: '90x48x188',
  },
  {
    imageSRC: piece20,
    material: 'Plaster',
    size: '95x50x145',
  },
  {
    imageSRC: piece21,
    material: 'Plaster, wood',
    size: '75x75x210',
  },
  {
    imageSRC: piece22,
    material: 'Plaster',
    size: '110x50x172',
  },
  {
    imageSRC: piece23,
    material: 'Marl',
    size: '20x16x36',
  },
  {
    imageSRC: piece24,
    material: 'Marl',
    size: '65x37x80',
  },
  {
    imageSRC: piece25,
    material: 'Marl',
    size: '90 ⌀',
  },
  {
    imageSRC: piece26,
    material: 'ceramics',
    size: '21x21x32',
  },
  {
    imageSRC: piece27,
    material: 'ceramics',
    size: '50x50x70',
  },
  {
    imageSRC: piece28,
    material: 'ceramics',
    size: '80x70x170',
  },
  {
    imageSRC: piece29,
    material: 'ceramics',
    size: '45x35x130',
  },
  {
    imageSRC: piece30,
    material: 'ceramics',
    size: '4x 45x35x130',
  },
  {
    imageSRC: piece31,
    material: 'ceramics',
    size: '45x45x55',
  },
  {
    imageSRC: piece32,
    material: 'ceramics',
    size: '35x25x70',
  },
  {
    imageSRC: piece33,
    material: 'ceramics',
    size: '62x55x10',
  },
  {
    imageSRC: piece34,
    material: 'ceramics',
    size: '35x25x50',
  },
  {
    imageSRC: piece35,
    material: 'ceramics',
    size: '130x50x50 & 60x50x45',
  },
  {
    imageSRC: piece36,
    material: 'ceramics',
    size: '130x50x45',
  },
  {
    imageSRC: piece37,
    material: 'ceramics',
    size: '40x33x150',
  },
  {
    imageSRC: piece38,
    material: 'ceramics',
    size: '165x70x40',
  },
  {
    imageSRC: piece39,
    material: 'bronze',
    size: '22x22x27',
  },
  // {
  //   imageSRC: piece40,
  //   material: "bronze",
  //   size: "22x22x27",
  // },
  {
    imageSRC: piece41,
    material: 'bronze',
    size: '110x90x172',
  },
  {
    imageSRC: piece42,
    material: 'bronze',
    size: '110x90x172',
  },
  {
    imageSRC: piece43,
    material: 'aluminium',
    size: '22x22x32',
  },
  {
    imageSRC: piece44,
    material: 'belgium marble',
    size: '29x17x9',
  },
  {
    imageSRC: piece45,
    material: 'Carrara marble',
    size: '36x12x12',
  },
  {
    imageSRC: piece46,
    material: 'Carrara marble',
    size: '57x35x20',
  },
  {
    imageSRC: piece47,
    material: 'Carrara marble',
    size: '57x35x20',
  },
  {
    imageSRC: piece48,
    material: 'pink Portuguese marble',
    size: '64x37x36',
  },
  {
    imageSRC: piece49,
    material: 'pink Portuguese marble',
    size: '64x37x36',
  },
  {
    imageSRC: piece50,
    material: 'Carrara marble',
    size: '23x18x52',
  },
  {
    imageSRC: piece51,
    material: 'Carrara marble',
    size: '44x44x28',
  },
  {
    imageSRC: piece52,
    material: 'Carrara marble',
    size: '48x43x26',
  },
  {
    imageSRC: piece53,
    material: 'oak',
    size: '170x90x34',
  },
  {
    imageSRC: piece54,
    material: 'oak',
    size: '84x84x107',
  },
  {
    imageSRC: piece55,
    material: 'oak',
    size: '84x84x107',
  },
  {
    imageSRC: piece56,
    material: 'oak',
    size: '33x20x25',
  },
  {
    imageSRC: piece57,
    material: 'oak',
    size: '42x182x8',
  },
  {
    imageSRC: piece58,
    material: '',
    size: '',
  },
  {
    imageSRC: piece59,
    material: 'maple',
    size: '30x35x55',
  },
  {
    imageSRC: piece60,
    material: 'birch',
    size: '28x28x42',
  },
  {
    imageSRC: piece61,
    material: '',
    size: '',
  },
  {
    imageSRC: piece62,
    material: 'oak',
    size: '33x22x35',
  },
  {
    imageSRC: piece63,
    material: 'maple',
    size: '35x20x52',
  },
  {
    imageSRC: piece64,
    material: 'poplar',
    size: '25x20x40',
  },
  {
    imageSRC: piece65,
    material: 'poplar',
    size: '20x20x40',
  },
  {
    imageSRC: piece66,
    material: 'poplar',
    size: '25x20x40',
  },
  {
    imageSRC: piece67,
    material: 'maple',
    size: '22x15x52',
  },
  {
    imageSRC: piece68,
    material: 'maple',
    size: '22x15x52',
  },
  {
    imageSRC: piece69,
    material: 'copper, aluminium foil',
    size: '90x90x200',
  },
  {
    imageSRC: piece70,
    material: 'copper, steal thread',
    size: 'local 01 Antwerp',
  },
  {
    imageSRC: piece71,
    material: 'aluminium, copper thread',
    size: '47x45x16',
  },
  {
    imageSRC: piece72,
    material: 'aluminium, copper',
    size: '550x90x450',
  },
  {
    imageSRC: piece73,
    material: 'aluminium, copper',
    size: '550x90x450',
  },
  {
    imageSRC: piece74,
    material: 'powder-coated steel',
    size: '21x0,5x3,5m',
  },
  {
    imageSRC: piece75,
    material: 'powder-coated steel',
    size: '14x0,5x3,5m',
  },
  {
    imageSRC: piece76,
    material: 'powder-coated steel',
    size: '14x0,5x3,5m',
  },
  {
    imageSRC: piece78,
    material: 'powder-coated steel',
    size: '14x0,5x3,5m',
  },
  {
    imageSRC: piece79,
    material: 'powder-coated steel',
    size: '14x0,5x3,5m',
  },
  {
    imageSRC: piece80,
    material: 'powder-coated steel',
    size: '14x0,5x3,5m',
  },
  {
    imageSRC: piece81,
    material: 'Porcelain, ceramics',
    size: '',
  },
  {
    imageSRC: piece82,
    material: 'Porcelain',
    size: '11x11x26',
  },
  {
    imageSRC: piece83,
    material: 'Porcelain',
    size: '11x11x26',
  },
  {
    imageSRC: piece84,
    material: 'Porcelain',
    size: '11x11x26 & 12x10x29',
  },
  {
    imageSRC: piece85,
    material: 'Porcelain',
    size: '11x11x26 & 22x12x24',
  },
  {
    imageSRC: piece86,
    material: 'Porcelain',
    size: '30x21x0,5',
  },
  {
    imageSRC: piece87,
    material: 'Porcelain',
    size: '26x20x10',
  },
  {
    imageSRC: piece88,
    material: 'maple',
    size: '10x10x18',
  },
  {
    imageSRC: piece89,
    material: 'oak',
    size: '31x33x9',
  },
  {
    imageSRC: piece90,
    material: 'oak',
    size: '36x18x5',
  },
  {
    imageSRC: piece91,
    material: 'linden',
    size: '23x10x35',
  },
  {
    imageSRC: piece92,
    material: 'linden',
    size: '23x10x35',
  },
];
